<template>
    <div>
        <div class="row">
            <div class="col-10">
                <p class="chat-title">{{ messageTitle }}</p>
            </div>
            <div class="col-2 text-right pr-3">
                <div v-if="!clientMessage">
                    <a
                        href="#"
                        title="Supprimer ce message"
                        @click="deleteMessage"
                    >
                        <i class="far fa-trash-alt"></i>
                    </a>
                </div>
            </div>
        </div>

        <b-form-input
            ref="blabla"
            v-model="form.message"
            :class="inputClass"
            @change="updateMessage"
            @click="edit"
        >
        </b-form-input>
    </div>
</template>

<script>
export default {
    name: 'CommentEdit',

    props: {
        comment: {},
    },

    data() {
        return {
            form: {},
            editing: false,
        }
    },

    computed: {
        inputClass() {
            return this.editing ? 'bg-white p-1' : 'border-0 bg-light p-1'
        },

        messageTitle() {
            return this.clientMessage
                ? `Réponse du client, ${this.comment.created_at}`
                : `${this.comment.accounting_firm_user.name}, ${this.comment.created_at}`
        },

        clientMessage() {
            return this.comment.accounting_firm_user === null
        },
    },

    created() {
        this.form.message = this.comment.message
    },

    methods: {
        edit() {
            this.editing = true
        },

        async updateMessage() {
            try {
                await axios.put(
                    `/pendingPointComments/${this.comment.id}`,
                    this.form
                )
                this.refreshComments()
            } catch (error) {
                console.log(error)
            }
        },

        async deleteMessage() {
            try {
                await axios.delete(`/pendingPointComments/${this.comment.id}`)
                this.refreshComments()
            } catch (error) {
                console.log(error)
            }
        },

        refreshComments() {
            this.editing = false
            this.unFocus()
            this.$parent.getComments()
        },

        unFocus() {
            this.$refs.blabla.blur()
        },
    },
}
</script>

<style scoped>
.chat-title {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 0;
}

.chat-message {
    margin-bottom: 0;
}
</style>
